import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/mir.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/mobile.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/sber.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/sbp.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/tinkoff.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/vk.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/dzen.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/odnoklassniki.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/ula.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/vk-cloud.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/vk-mail.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/components/StrapiHeader/Header.tsx");
